import React from "react";
import { ArcStack } from "@src/core/ui";
import { HistoryPageSidebar } from "./sidebar";
import { HistoryPageContent } from "./content";

const HistoryPage: React.FC = () => {
  return (
    <ArcStack direction="row">
      <HistoryPageSidebar />
      <HistoryPageContent />
    </ArcStack>
  );
};

export { HistoryPage };
